// extracted by mini-css-extract-plugin
export default {"documentNameLink":"styles_documentNameLink__-515n"};